(() => {
  const STORAGE_KEY = 'mcor_fit_guide_vehicle_v1';
  const FIT_GUIDE_PATH = '/pages/speaker-fit-guide';
  const VEHICLE_PARAMS = {
    year: 'fg_year',
    make: 'fg_make',
    model: 'fg_model',
    submodel: 'fg_submodel',
    body_style: 'fg_body',
    screen: 'fg_screen',
    amplifier: 'fg_amp',
    hvac: 'fg_hvac',
    key_type: 'fg_key',
    transmission: 'fg_trans',
    powertrain: 'fg_powertrain',
  };

  const AUTHORITY_COLLECTIONS = {
    audison: 'Audison',
    'axxess-installation-products': 'Axxess',
    compustar: 'Compustar',
    hertz: 'Hertz',
    'idatalink-maestro': 'iDatalink Maestro',
    kenwood: 'Kenwood',
    'kicker-audio': 'KICKER',
    'metra-installation-products': 'Metra',
    'momento-dash-cameras-accessories': 'Momento',
    'pac-integration-installation-products': 'PAC',
    sony: 'Sony',
    'stinger-electronics-vehicle-integration': 'Stinger',
  };

  const escapeHtml = (value) =>
    String(value || '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');

  const readVehicle = () => {
    try {
      return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
    } catch (_error) {
      return null;
    }
  };

  const hasVehicle = (vehicle) => Boolean(vehicle?.year && vehicle?.make && vehicle?.model);
  const vehicleLabel = (vehicle) =>
    hasVehicle(vehicle) ? [vehicle.year, vehicle.make, vehicle.model].filter(Boolean).join(' ') : '';

  const fitGuideUrl = (anchor) => {
    const url = new URL(FIT_GUIDE_PATH, window.location.origin);
    const vehicle = readVehicle();
    if (hasVehicle(vehicle)) {
      Object.entries(VEHICLE_PARAMS).forEach(([field, parameter]) => {
        if (vehicle[field]) url.searchParams.set(parameter, vehicle[field]);
      });
    }
    url.hash = anchor;
    return `${url.pathname}${url.search}${url.hash}`;
  };

  const addStyles = () => {
    if (document.getElementById('McorCategoryConversionStyles')) return;
    const style = document.createElement('style');
    style.id = 'McorCategoryConversionStyles';
    style.textContent = `
      .mcor-category-conversion{margin:1.6rem 0;padding:1.8rem;border:1px solid rgba(var(--color-foreground),.16);border-left:4px solid #e21b23;border-radius:12px;background:rgba(var(--color-foreground),.025)}
      .mcor-category-conversion__eyebrow{margin:0 0 .45rem;color:#d71920;font-size:1.1rem;font-weight:800;letter-spacing:.09em;text-transform:uppercase}
      .mcor-category-conversion h2{margin:0 0 .65rem;font-size:clamp(1.8rem,2.2vw,2.35rem);line-height:1.15}
      .mcor-category-conversion__copy{margin:0 0 1.25rem;color:rgba(var(--color-foreground),.78);line-height:1.55}
      .mcor-category-conversion__actions{display:flex;flex-wrap:wrap;gap:.8rem;align-items:center}
      .mcor-category-conversion__primary{display:inline-flex;align-items:center;justify-content:center;min-height:4.5rem;padding:.9rem 1.4rem;border-radius:8px;background:#e21b23;color:#fff;text-decoration:none;font-weight:800;text-align:center}
      .mcor-category-conversion__primary:hover{background:#b9141a;color:#fff}
      .mcor-category-conversion__secondary{color:rgb(var(--color-foreground));font-weight:700;text-underline-offset:.3rem}
      .mcor-category-trust{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:.65rem 1.2rem;margin-top:1.35rem;padding-top:1.15rem;border-top:1px solid rgba(var(--color-foreground),.12);font-size:1.2rem;font-weight:650}
      .mcor-category-trust span::before{content:'✓';margin-right:.45rem;color:#118047;font-weight:900}
      .mcor-authority-filter-summary{display:flex;align-items:center;justify-content:space-between;gap:1.2rem;margin:0 auto 2rem;padding:1.4rem 1.6rem;border:1px solid rgba(var(--color-foreground),.14);border-radius:10px;background:rgba(var(--color-foreground),.025)}
      .mcor-authority-filter-summary strong{display:block;font-size:1.55rem}
      .mcor-authority-filter-summary span{display:block;margin-top:.2rem;color:rgba(var(--color-foreground),.7)}
      .mcor-authority-filter-summary a{white-space:nowrap;font-weight:800;text-underline-offset:.3rem}
      body.mcor-authority-filtered-collection .mcor-authority-hub{display:none!important}
      body.mcor-authority-filtered-collection .collection-hero__description{display:none!important}
      body.mcor-authority-filtered-collection .collection-hero__inner{padding-bottom:1.5rem!important}
      @media(max-width:749px){.mcor-category-conversion{padding:1.5rem}.mcor-category-conversion__primary{width:100%}.mcor-category-trust{grid-template-columns:1fr}.mcor-authority-filter-summary{align-items:flex-start;flex-direction:column}.mcor-authority-filter-summary a{white-space:normal}}
    `;
    document.head.appendChild(style);
  };

  const productHandle = () => {
    const canonical = document.querySelector('link[rel="canonical"]')?.href || window.location.href;
    const match = new URL(canonical, window.location.origin).pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  };

  const loadProduct = async () => {
    const handle = productHandle();
    if (!handle) return null;
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}products/${encodeURIComponent(handle)}.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) return null;
    return response.json();
  };

  const normalizedProduct = (product) => ({
    vendor: String(product.vendor || '').trim(),
    vendorKey: String(product.vendor || '').trim().toLowerCase(),
    type: String(product.type || product.product_type || '').trim(),
    title: String(product.title || '').trim(),
    tags: Array.isArray(product.tags) ? product.tags.join(' ') : String(product.tags || ''),
  });

  const productKind = (product) => {
    const data = normalizedProduct(product);
    const corpus = `${data.type} ${data.title} ${data.tags}`.toLowerCase();
    if (data.vendorKey === 'jl audio' || /marine|powersports|utv|atv/.test(corpus)) return null;

    if (
      data.vendorKey === 'stinger' &&
      data.type === 'Vehicle-Specific Multimedia Receiver Package'
    ) return 'vehicle_specific_receiver';

    if (
      data.vendorKey === 'kenwood' &&
      data.type === 'Motor Vehicle A/V Players & In-Dash Systems' &&
      /direct fit|direct-fit|dax8000s|dax800xr|dax1050xr/.test(corpus)
    ) return 'direct_fit_receiver';

    if (
      ['kenwood', 'sony', 'jvc', 'stinger'].includes(data.vendorKey) &&
      ['Motor Vehicle A/V Players & In-Dash Systems', 'Digital Multimedia Receiver'].includes(data.type)
    ) return 'receiver';

    if (
      ['Motor Vehicle Speakers', 'Car Speakers', 'Coaxial Speakers', 'Component Car Speakers'].includes(data.type)
    ) {
      if (/speaker grilles?/.test(corpus)) return null;
      return 'speaker';
    }

    if (
      data.vendorKey === 'compustar' &&
      [
        'Remote Start Module',
        'Remote Start System',
        'Remote Start & Security System',
        'Vehicle Security System',
        'Remote Start & Security Controller',
        'Remote Start Controller',
      ].includes(data.type)
    ) {
      return 'remote_start';
    }

    if (data.type === 'Motor Vehicle Amplifiers' && !/interface|adapter|harness/.test(corpus)) {
      return 'amplifier';
    }

    if (data.type === 'Loaded Subwoofer Enclosure') {
      return 'loaded_enclosure';
    }

    if (['Motor Vehicle Subwoofers', 'Car Subwoofer'].includes(data.type)) {
      if (/\b51dbrc\b|dual bass remote control/.test(corpus)) return null;
      return 'subwoofer';
    }

    if (
      ['momento', 'kenwood'].includes(data.vendorKey) &&
      data.type === 'Dashboard Camera' &&
      /dash cam|dash camera/.test(corpus) &&
      !/replacement|accessory|cable|harness|mount/.test(corpus)
    ) return 'dash_camera';

    return null;
  };

  const vendorFilterUrl = (vendor, type) => {
    const url = new URL('/collections/all', window.location.origin);
    url.searchParams.set('filter.p.vendor', vendor);
    if (type) url.searchParams.set('filter.p.product_type', type);
    return `${url.pathname}${url.search}`;
  };

  const panelContent = (kind, product, savedLabel) => {
    const data = normalizedProduct(product);
    if (String(product.id) === '9878966173975' && kind === 'subwoofer') {
      return {
        eyebrow: 'Complete your powered-bass installation',
        heading: 'Your HS10 includes the amplifier and enclosure',
        copy: savedLabel
          ? `Confirm mounting space, secure installation, power wiring, and the factory-audio signal connection for your saved ${savedLabel}. This powered HS10 does not need a separate subwoofer amplifier or enclosure; vehicle-specific integration parts may still be required.`
          : 'Confirm mounting space, secure installation, power wiring, and your factory-audio signal connection. This powered HS10 does not need a separate subwoofer amplifier or enclosure; vehicle-specific integration parts may still be required.',
        cta: 'Check integration for my vehicle',
        href: fitGuideUrl('mfg-integration'),
        secondary: '/collections/kicker-audio#mcor-powered-bass-choice',
        secondaryLabel: 'Compare Kicker powered-bass options',
      };
    }
    if (kind === 'vehicle_specific_receiver') {
      return {
        eyebrow: 'Confirm the vehicle-specific package',
        heading: 'Verify this complete radio package for your exact vehicle',
        copy: savedLabel
          ? `Confirm that this ${data.vendor} package matches the year, model, trim, factory radio, amplifier, screen, and climate-control configuration of your saved ${savedLabel}.`
          : `Choose your vehicle to verify this ${data.vendor} package against the exact trim and factory-equipment requirements before ordering.`,
        cta: 'Check this package for my vehicle',
        href: fitGuideUrl('mfg-radios'),
        secondary: vendorFilterUrl(data.vendor, data.type),
        secondaryLabel: `Compare ${data.vendor} vehicle-specific radios`,
      };
    }
    if (kind === 'direct_fit_receiver') {
      return {
        eyebrow: 'Build the complete Direct-Fit system',
        heading: 'Match this receiver with every part your vehicle requires',
        copy: savedLabel
          ? `Build the verified receiver, vehicle kit, Maestro module, and required-accessory path for your saved ${savedLabel}. The system builder keeps mandatory pieces together.`
          : 'Choose your vehicle to build the receiver, exact dash and integration kit, Maestro module, and every mandatory accessory as one functional system.',
        cta: 'Build this system for my vehicle',
        href: fitGuideUrl('mfg-radios'),
        secondary: '/collections/kenwood?filter.p.tag=Direct%20Fit',
        secondaryLabel: 'Compare Kenwood Direct-Fit receivers',
      };
    }
    if (kind === 'receiver') {
      return {
        eyebrow: 'Complete the radio installation',
        heading: 'Find the dash kit, interface, and adapters this radio needs',
        copy: savedLabel
          ? `See the verified radio-installation paths for your saved ${savedLabel}, including the dash kit, interface or harness, antenna adapter, and retention parts when applicable.`
          : 'Choose your vehicle to find the dash kit, interface or harness, antenna adapter, and feature-retention parts required for a complete installation.',
        cta: 'Find my installation parts',
        href: fitGuideUrl('mfg-radio-installation'),
        secondary: vendorFilterUrl(data.vendor, data.type),
        secondaryLabel: `Compare ${data.vendor} car stereos`,
      };
    }
    if (kind === 'speaker') {
      return {
        eyebrow: 'Vehicle fitment check',
        heading: 'Make sure this speaker fits your vehicle',
        copy: savedLabel
          ? `Check the factory speaker opening and the brackets or harnesses required for your saved ${savedLabel}.`
          : 'Choose your vehicle to see the factory speaker locations, opening sizes, and installation parts that apply.',
        cta: 'Check this speaker for my vehicle',
        href: fitGuideUrl('mfg-speakers'),
        secondary: vendorFilterUrl(data.vendor, data.type),
        secondaryLabel: `Compare ${data.vendor} car speakers`,
      };
    }
    if (kind === 'remote_start') {
      return {
        eyebrow: 'Vehicle application required',
        heading: 'Build the complete remote-start and security path',
        copy: savedLabel
          ? `Check key type, transmission, powertrain, firmware, and the required vehicle harness or interface for your saved ${savedLabel}.`
          : 'Choose your vehicle to verify key type, transmission, powertrain, firmware, and every required harness or interface before ordering.',
        cta: 'Check remote start for my vehicle',
        href: fitGuideUrl('mfg-security'),
        secondary: vendorFilterUrl(data.vendor, data.type),
        secondaryLabel: 'Compare Compustar systems',
      };
    }
    if (kind === 'amplifier') {
      return {
        eyebrow: 'Complete the amplifier installation',
        heading: 'Plan the signal, power, and factory-audio integration',
        copy: savedLabel
          ? `Find the factory-audio integration path and vehicle-specific signal connections for your saved ${savedLabel}; power wiring and tuning still depend on the complete system design.`
          : 'Choose your vehicle to find applicable factory-audio integration interfaces and signal connections, then size the power wiring and tuning for the complete system.',
        cta: 'Find integration parts for my vehicle',
        href: fitGuideUrl('mfg-integration'),
        secondary: vendorFilterUrl(data.vendor, data.type),
        secondaryLabel: `Compare ${data.vendor} amplifiers`,
      };
    }
    if (kind === 'loaded_enclosure') {
      return {
        eyebrow: 'Vehicle and system fit check',
        heading: 'Confirm enclosure fit and complete the bass-system installation',
        copy: savedLabel
          ? `See the vehicle-specific enclosure and factory-audio integration paths for your saved ${savedLabel}; amplifier matching still depends on the enclosure's final load and power requirements.`
          : 'Choose your vehicle to check exact-fit enclosure options and factory-audio integration, then match the amplifier to the enclosure load and power requirements.',
        cta: 'Check bass-system options for my vehicle',
        href: fitGuideUrl('mfg-audio-upgrades'),
        secondary: vendorFilterUrl(data.vendor, data.type),
        secondaryLabel: `Compare ${data.vendor} loaded enclosures`,
      };
    }
    if (kind === 'subwoofer') {
      return {
        eyebrow: 'Build the complete bass system',
        heading: 'Match the subwoofer, enclosure, amplifier, and integration',
        copy: savedLabel
          ? `See the factory-audio integration path for your saved ${savedLabel}, then match enclosure type, final impedance, and amplifier power as one system.`
          : 'Choose your vehicle to find applicable factory-audio integration, then match enclosure type, final impedance, and amplifier power as one complete system.',
        cta: 'Plan bass integration for my vehicle',
        href: fitGuideUrl('mfg-integration'),
        secondary: vendorFilterUrl(data.vendor, data.type),
        secondaryLabel: `Compare ${data.vendor} subwoofers`,
      };
    }
    return {
      eyebrow: 'Complete the dash-camera installation',
      heading: 'Choose the coverage, power, and parking-mode setup you need',
      copy: 'Confirm the included front and rear cameras, then add the correct hardwire power option, memory capacity, and parking-mode accessories for the way you want the system to record.',
      cta: `Shop ${data.vendor} cameras and accessories`,
      href: data.vendorKey === 'momento'
        ? '/collections/momento-dash-cameras-accessories'
        : vendorFilterUrl(data.vendor, data.type),
      secondary: '/pages/contact',
      secondaryLabel: 'Ask MCOR about dash-camera setup',
    };
  };

  const trackCta = (kind, product) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'mcor_product_intent_cta_click',
      mcor_cta_kind: kind,
      product_id: product.id,
      product_title: product.title,
      product_vendor: product.vendor,
    });
  };

  const renderProductBridge = async () => {
    if (!window.location.pathname.includes('/products/')) return;
    const product = await loadProduct().catch(() => null);
    if (!product) return;
    const kind = productKind(product);
    if (!kind || document.querySelector('[data-mcor-category-conversion]')) return;

    const info = document.querySelector('product-info .product__info-container, .product__info-container');
    const purchaseForm = info?.querySelector('product-form, .product-form');
    if (!info || !purchaseForm) return;

    const content = panelContent(kind, product, vehicleLabel(readVehicle()));
    const productData = normalizedProduct(product);
    const panel = document.createElement('section');
    panel.className = 'mcor-category-conversion';
    panel.dataset.mcorCategoryConversion = kind;
    panel.setAttribute('aria-labelledby', 'McorCategoryConversionHeading');
    panel.innerHTML = `
      <p class="mcor-category-conversion__eyebrow">${escapeHtml(content.eyebrow)}</p>
      <h2 id="McorCategoryConversionHeading">${escapeHtml(content.heading)}</h2>
      <p class="mcor-category-conversion__copy">${escapeHtml(content.copy)}</p>
      <div class="mcor-category-conversion__actions">
        <a class="mcor-category-conversion__primary" data-mcor-category-primary href="${escapeHtml(content.href)}">${escapeHtml(content.cta)}</a>
        <a class="mcor-category-conversion__secondary" href="${escapeHtml(content.secondary)}">${escapeHtml(content.secondaryLabel)}</a>
      </div>
      <div class="mcor-category-trust" aria-label="Why buy ${escapeHtml(productData.vendor)} from MCOR">
        <span>Authorized ${escapeHtml(productData.vendor)} retailer</span>
        <span>Trusted by hundreds of verified customers</span>
        <span>Installation expertise since 2004</span>
        <span>Fast U.S. shipping and straightforward returns</span>
      </div>
    `;
    purchaseForm.insertAdjacentElement('beforebegin', panel);
    panel.querySelector('[data-mcor-category-primary]')?.addEventListener('click', () => trackCta(kind, product));
  };

  const activeAuthorityFilter = () => {
    const match = window.location.pathname.match(/^\/collections\/([^/]+)\/?$/);
    if (!match || !AUTHORITY_COLLECTIONS[match[1]] || match[1] === 'jl-audio') return null;
    const params = new URLSearchParams(window.location.search);
    const active = [...params.entries()].find(([key, value]) => key.startsWith('filter.') && value);
    if (!active) return null;
    return { handle: match[1], brand: AUTHORITY_COLLECTIONS[match[1]], filterValue: active[1] };
  };

  const renderFilteredCollection = () => {
    const active = activeAuthorityFilter();
    if (!active) return;
    document.body.classList.add('mcor-authority-filtered-collection');
    const facets = document.querySelector('.facets-container');
    if (!facets || document.querySelector('[data-mcor-authority-filter-summary]')) return;

    const summary = document.createElement('div');
    summary.className = 'mcor-authority-filter-summary page-width';
    summary.dataset.mcorAuthorityFilterSummary = '';
    summary.innerHTML = `
      <div><strong>${escapeHtml(active.brand)} ${escapeHtml(active.filterValue)}</strong><span>Showing the products in the category you selected.</span></div>
      <a href="/collections/${escapeHtml(active.handle)}">View the complete ${escapeHtml(active.brand)} collection</a>
    `;
    facets.insertAdjacentElement('beforebegin', summary);
  };

  const init = () => {
    addStyles();
    renderFilteredCollection();
    renderProductBridge();
  };

  document.addEventListener('DOMContentLoaded', init, { once: true });
})();
